import scoutApi from '@/api/scoutApi'
import scoutRepo from '@/repos/scoutRepo'

let debug = false;

export default {

    async fetchAndStoreScoutings(options) {
        // try to fetch data from server
        let scoutings = await scoutApi.getScoutings(options.plantIDs);

        if (debug) console.log("fetchAndStoreScoutings(), scoutings: ", scoutings);

        // store the data we got from the server in the appropriate place in memory

        await scoutRepo.clearScoutings();

        if (scoutings) {
            await scoutRepo.putScoutings(scoutings);
        }
    },

    async fetchAndStorePestConfigurations(options) {
        // try to fetch data from server
        let pestConfigurations = await scoutApi.getPestConfigurations(options.plantIDs);

        if (debug) console.log("fetchAndStorePestConfigurations(), pestConfigurations: ", pestConfigurations);

        // store the data we got from the server in the appropriate place in memory

        await scoutRepo.clearPestConfigurations();

        if (pestConfigurations) {
            await scoutRepo.addPestConfigurations(pestConfigurations);
        }
    },

    async fetchAndStoreScoutingCropStages() {
        let cropStages = await scoutApi.getScoutingCropStages();

        await scoutRepo.clearScoutingCropStages();

        if (cropStages) {
            await scoutRepo.addScoutingCropStages(cropStages);
        }
    },

    async saveScout(options) {
        if (debug) console.log("saveScout(), scouting: ", JSON.stringify(options.scouting));

        await scoutRepo.addUnsyncedScouting(options.scouting);

        return await this.postUnsyncedData(options);
    },

    async postUnsyncedData(options) {
        let unsyncedScoutings = await scoutRepo.getUnsyncedScoutings();

        if (debug) console.log("postUnsyncedData(), unsyncedScoutings: ", JSON.stringify(unsyncedScoutings));

        let result = await scoutApi.batchProcessUnsyncedScoutings(unsyncedScoutings, options.plantIDs);
        if (result) {
            // we have successfully sent these unsynced records, so we can clear them from the list now
            await scoutRepo.clearUnsyncedScouts();

            // bulk put the newly loaded data from the server            
            await scoutRepo.putScoutings(result.Scoutings);

            // Add all the errored scouting as they have not been resolved yet
            for(let i = 0; i < result.Errors.length; i++){
                let scouting = result.Errors[i].Scouting;

                await scoutRepo.addUnsyncedScouting(scouting);
            }

            return result.Errors;
        }

        return [];
    },

    async getUnsyncedScoutings() {
        return await scoutRepo.getUnsyncedScoutings();
    },

    async getNextScoutingNegativeID() {
        const unsent = await scoutRepo.getUnsyncedScoutings();

        let newID = -1;

        unsent.forEach(item => {
            if (item.ScoutingID <= newID) {
                newID = item.ScoutingID - 1;
            }
        });

        return newID;
    }    
}

